// @flow
import React, {PureComponent} from 'react';
import './SliderHandle.less';

export type Props = {
    index: number,
    onSetActiveHandle?: (index: ?number) => void
};

export default class SliderHandle extends PureComponent<Props> {
    handleBlur = (event: SyntheticEvent<HTMLInputElement>) => {
        const {onSetActiveHandle} = this.props;

        if (onSetActiveHandle) {
            onSetActiveHandle(null);
        }

        event.stopPropagation();
    };

    onBecomeActive = () => {
        const {index, onSetActiveHandle} = this.props;

        if (onSetActiveHandle) {
            onSetActiveHandle(index);
        }
    };

    render() {
        const {index} = this.props;

        return (
            <div
                className={`SliderHandle__handle SliderHandle__handle-${index}`}
                key={index}
                onMouseDown={this.onBecomeActive}
                onTouchStart={this.onBecomeActive}
                onFocus={this.onBecomeActive}
                onBlur={this.handleBlur}
            />
        );
    }
}
